/*
  Capa de búsqueda a pantalla completa (tipo Doofinder) — markup en snippets/tc-header-search.liquid.
  1. Pide /search?q=…&section_id=tc-search-results (JSON con los 250 primeros resultados de Shopify, por relevancia).
  2. La búsqueda de Shopify es semántica y devuelve muchos productos "relacionados": aquí se separan los
     resultados exactos (todas las palabras aparecen en nombre, gama, categoría, tipo o etiquetas) del resto.
  3. Agrupa las familias de formatos (custom.formatos), calcula los filtros Categoría / Gama / Precio y ordena.
  La búsqueda queda en la URL (#tc-search?q=…) para poder compartirla y para que "atrás" cierre la capa.
*/
(() => {
  const root = document.getElementById('tc-search-overlay');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  root.classList.add('tc-pdp');

  const T = JSON.parse(root.querySelector('[data-tc-so-i18n]').textContent);
  const input = root.querySelector('[data-tc-so-input]');
  const body = root.querySelector('[data-tc-so-body]');
  const chipsBox = root.querySelector('[data-tc-so-chips]');
  const popularHTML = chipsBox.innerHTML;
  const PAGE = 24;
  const HASH = '#tc-search';

  const state = { q: '', data: null, cats: new Set(), gamas: new Set(), pmin: null, pmax: null, sort: 'rel', shown: PAGE, catOpen: false, catFind: '' };
  let cssLoaded = false, timer, ctrl, opened = false, ownEntry = false;

  // ---------- helpers ----------
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const fmt = (cents) => {
    try { return new Intl.NumberFormat(root.dataset.locale || 'es', { style: 'currency', currency: root.dataset.currency || 'EUR' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + ' €'; }
  };
  // normalise for matching: lower case, no accents/symbols, collapse doubled letters (Sttandard ~ standard),
  // light Spanish stemming (barniz/barnices, molde/moldes)
  const stem = (w) => {
    w = w.replace(/z/g, 'c');
    if (w.length > 4 && w.endsWith('es')) return w.slice(0, -2);
    if (w.length > 3 && w.endsWith('s')) return w.slice(0, -1);
    return w;
  };
  const words = (s) => String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, ' ').replace(/(.)\1+/g, '$1').trim().split(' ').filter(Boolean).map(stem);

  // synonym groups from the theme setting "Búsqueda Topciment > Sinónimos" (one group per line, comma separated)
  const SYN = String(T.syn || '').split(/\r?\n/).map((l) => l.split(',').map((t) => ({ raw: t.trim(), w: words(t) })).filter((t) => t.w.length)).filter((g) => g.length > 1);
  // groups whose terms appear in the query (whole words, after normalising)
  const synFor = (q) => {
    const qn = ' ' + words(q).join(' ') + ' ';
    return SYN.map((g) => ({ g, hit: g.find((t) => qn.includes(' ' + t.w.join(' ') + ' ')) })).filter((x) => x.hit);
  };

  const loadCss = () => {
    if (cssLoaded) return;
    cssLoaded = true;
    root.dataset.css.split('|').forEach((href) => {
      if (document.querySelector(`link[href="${href}"]`)) return;
      const l = document.createElement('link');
      l.rel = 'stylesheet'; l.href = href;
      document.head.appendChild(l);
    });
  };

  // ---------- open / close ----------
  const open = (q = '', push = true) => {
    loadCss();
    root.hidden = false;
    document.documentElement.classList.add('tc-so-lock');
    if (push && !opened) { history.pushState({ tcSo: 1 }, '', HASH + (q ? '?q=' + encodeURIComponent(q) : '')); ownEntry = true; }
    opened = true;
    input.value = q;
    setTimeout(() => { input.focus(); input.setSelectionRange(q.length, q.length); }, 30);
    search(q);
  };
  const close = (fromPop = false) => {
    root.hidden = true;
    document.documentElement.classList.remove('tc-so-lock');
    opened = false;
    if (!fromPop && location.hash.startsWith(HASH)) {
      // went in through our own history entry: go back; came from a shared link: just drop the hash
      if (ownEntry) history.back(); else history.replaceState(null, '', location.pathname + location.search);
    }
    ownEntry = false;
  };
  root.querySelector('[data-tc-so-close]').addEventListener('click', () => close());
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !root.hidden) close(); });
  window.addEventListener('popstate', () => {
    if (location.hash.startsWith(HASH)) open(new URLSearchParams(location.hash.split('?')[1] || '').get('q') || '', false);
    else if (!root.hidden) close(true);
  });

  // header field (desktop) opens the overlay as soon as you type or submit
  document.querySelectorAll('[data-tc-so-open]').forEach((form) => {
    const hin = form.querySelector('input[name="q"]');
    form.addEventListener('submit', (e) => { e.preventDefault(); open(hin.value.trim()); hin.value = ''; hin.blur(); });
    hin.addEventListener('input', () => { if (hin.value.trim().length >= 1) { const v = hin.value; hin.value = ''; hin.blur(); open(v); } });
  });
  // theme magnifier (mobile / narrow screens) opens the overlay instead of the theme drawer
  document.addEventListener('click', (e) => {
    const t = e.target.closest('.top-search-toggle');
    if (!t) return;
    e.preventDefault(); e.stopImmediatePropagation();
    open('');
  }, true);

  // ---------- search ----------
  input.addEventListener('input', () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      const q = input.value.trim();
      history.replaceState(history.state, '', HASH + (q ? '?q=' + encodeURIComponent(q) : ''));
      search(q);
    }, 250);
  });
  root.querySelector('[data-tc-so-form]').addEventListener('submit', (e) => { e.preventDefault(); clearTimeout(timer); search(input.value.trim()); });

  const resetFilters = () => { state.cats.clear(); state.gamas.clear(); state.pmin = state.pmax = null; state.shown = PAGE; state.catFind = ''; };

  async function search(q) {
    if (q === state.q && state.data) return render();
    state.q = q;
    resetFilters();
    if (q.length < 2) {
      state.data = null;
      chipsBox.innerHTML = popularHTML;
      body.className = 'tc-so__body is-empty';
      body.innerHTML = '';
      return;
    }
    if (ctrl) ctrl.abort();
    ctrl = new AbortController();
    body.classList.add('tc-so__loading');
    try {
      // view=tc -> templates/search.tc.json (no layout) renders only sections/tc-search-results.liquid
      // ask Shopify for the synonyms too: "sellador OR barniz OR sealer…"
      const extra = [...new Set(synFor(q).flatMap((x) => x.g.filter((t) => t !== x.hit).map((t) => t.raw)))].slice(0, 8);
      const sq = extra.length ? [q, ...extra].map((t) => (t.includes(' ') ? '"' + t + '"' : t)).join(' OR ') : q;
      const url = root.dataset.url + '?' + new URLSearchParams({ q: sq, type: 'product', 'options[prefix]': 'last', 'options[unavailable_products]': 'last', view: 'tc' });
      const [html] = await Promise.all([(await fetch(url, { signal: ctrl.signal })).text(), suggest(q, ctrl.signal)]);
      const m = html.match(/data-tc-sr>([\s\S]*?)<\/script>/);
      state.data = prepare(JSON.parse(m[1]), q);
      render();
      track(q, state.data.exactCount);
    } catch (e) {
      if (e.name !== 'AbortError') { console.error('tc-search', e); body.className = 'tc-so__body is-empty'; body.innerHTML = `<p class="tc-so__hint">${esc(T.no_results)}</p>`; }
    } finally { body.classList.remove('tc-so__loading'); }
  }

  // query suggestions + matching categories/gamas from Shopify predictive search
  async function suggest(q, signal) {
    try {
      const p = new URLSearchParams({ q, 'resources[type]': 'query,collection', 'resources[limit]': '6' });
      const d = await (await fetch(root.dataset.suggest + '.json?' + p, { signal })).json();
      const r = (d.resources && d.resources.results) || {};
      const qs = (r.queries || []).map((x) => x.text).filter((t) => t.toLowerCase() !== q.toLowerCase()).slice(0, 5);
      const cs = (r.collections || []).slice(0, 4);
      if (!qs.length && !cs.length) { chipsBox.innerHTML = ''; return; }
      chipsBox.innerHTML = (qs.length ? `<span class="tc-so__chips-label">${esc(T.suggestions)}</span>` : '') +
        qs.map((t) => `<button type="button" class="tc-so__chip" data-q="${esc(t)}">${esc(t)}</button>`).join('') +
        cs.map((c) => `<a class="tc-so__chip tc-so__chip--link" href="${esc(c.url.split('?')[0])}">${esc(c.title)} →</a>`).join('');
    } catch (e) { if (e.name === 'AbortError') throw e; }
  }
  chipsBox.addEventListener('click', (e) => {
    const b = e.target.closest('[data-q]');
    if (!b) return;
    input.value = b.dataset.q;
    input.dispatchEvent(new Event('input'));
  });

  // ---------- data ----------
  function prepare(d, q) {
    // query words covered by a synonym group become one requirement: "any term of the group"
    const groups = synFor(q);
    const covered = new Set(groups.flatMap((x) => x.hit.w));
    const tokens = [...new Set(words(q))].filter((t) => t.length >= 2 && !covered.has(t));
    const termHit = (it, t) => t.w.every((tk) => it.hay.some((w) => w.startsWith(tk)));
    const catTitles = d.cats || {};
    d.items.forEach((it, idx) => {
      it.idx = idx;
      it.c = (it.c || []).filter((h) => catTitles[h]);
      it.hay = words([it.n, it.t, it.g, it.y, it.tg, it.c.map((h) => catTitles[h].t).join(' ')].join(' '));
      it.hits = tokens.filter((tk) => it.hay.some((w) => w.startsWith(tk))).length + groups.filter((x) => x.g.some((t) => termHit(it, t))).length;
    });
    const need = tokens.length + groups.length;
    let exact = d.items.filter((it) => need && it.hits === need);
    let partial = false;
    if (!exact.length && need > 1) { exact = d.items.filter((it) => it.hits > 0); partial = exact.length > 0; }
    const exactIds = new Set(exact.map((x) => x.id));
    const rest = d.items.filter((it) => !exactIds.has(it.id));
    const fams = group(exact);
    return {
      cats: catTitles, fams, partial,
      exactCount: fams.length,
      related: group(rest).slice(0, 8),
      pBounds: fams.length ? [Math.floor(Math.min(...fams.map((f) => f.p)) / 100), Math.ceil(Math.max(...fams.map((f) => f.p)) / 100)] : [0, 0],
    };
  }
  // one card per formats family; keep the best-ranked member as the card
  function group(items) {
    const map = new Map();
    items.forEach((it) => {
      let f = map.get(it.f);
      if (!f) { f = { ...it, members: [] }; map.set(it.f, f); }
      f.members.push(it);
    });
    return [...map.values()].map((f) => {
      const m = f.members;
      const ks = [...new Set(m.map((x) => x.k).filter(Boolean))].sort((a, b) => parseFloat(a.replace(',', '.')) - parseFloat(b.replace(',', '.')));
      return {
        ...f,
        p: Math.min(...m.map((x) => x.p)),
        a: m.some((x) => x.a),
        k: ks.join(' · '),
        c: [...new Set(m.flatMap((x) => x.c))],
        multi: m.length > 1,
        // several formats -> base name ('Sttandard Microbase'); a single product keeps its full title
        n: m.length > 1 ? (f.n || f.t) : f.t,
      };
    });
  }

  // ---------- filtering ----------
  const passes = (f, skip) =>
    (skip === 'cat' || !state.cats.size || f.c.some((h) => state.cats.has(h))) &&
    (skip === 'gama' || !state.gamas.size || state.gamas.has(f.g)) &&
    (skip === 'price' || ((state.pmin == null || f.p >= state.pmin * 100) && (state.pmax == null || f.p <= state.pmax * 100)));

  function filtered() {
    const list = state.data.fams.filter((f) => passes(f));
    const by = {
      rel: (a, b) => a.idx - b.idx,
      pa: (a, b) => a.p - b.p,
      pd: (a, b) => b.p - a.p,
      az: (a, b) => a.n.localeCompare(b.n),
    }[state.sort];
    return list.sort(by);
  }

  // ---------- render ----------
  const card = (f) => {
    const price = (f.multi ? T.from.replace('[price]', fmt(f.p)) : fmt(f.p));
    return `<article class="tc-gcard">
      <a class="tc-gcard__img" href="${esc(f.u)}">${f.i ? `<img src="${esc(f.i)}" alt="${esc(f.t)}" loading="lazy" width="400" height="400">` : ''}${f.a ? '' : `<span class="tc-gcard__badge tc-gcard__badge--out">${esc(T.sold_out)}</span>`}</a>
      <div class="tc-gcard__body">
        ${f.g ? `<span class="tc-so__gama">${esc(f.g)}</span>` : ''}
        <a class="tc-gcard__name" href="${esc(f.u)}">${esc(f.n)}</a>
        <div class="tc-gcard__foot"><span class="tc-gcard__price">${esc(price)}</span>${f.k ? `<span class="tc-gcard__formats">${esc(f.k)}</span>` : ''}</div>
        <a class="tc-gcard__btn" href="${esc(f.u)}">${esc(T.view)}</a>
      </div>
    </article>`;
  };

  // small horizontal card, same look as 'Completa tu sistema' on the product page (.tc-card)
  const smallCard = (f) => `<div class="tc-card">
      <a class="tc-card__img" href="${esc(f.u)}">${f.i ? `<img src="${esc(f.i.replace('width=400', 'width=200'))}" alt="${esc(f.t)}" loading="lazy" width="84" height="84">` : ''}</a>
      <div class="tc-card__body">
        <a class="tc-card__name" href="${esc(f.u)}">${esc(f.n)}</a>
        <span class="tc-card__price">${esc(f.multi ? T.from.replace('[price]', fmt(f.p)) : fmt(f.p))}</span>
        <a class="tc-so__card-link" href="${esc(f.u)}">${esc(T.view)} →</a>
      </div>
    </div>`;

  function facetList(key, title, values) {
    const sel = key === 'cat' ? state.cats : state.gamas;
    const isCat = key === 'cat';
    let vals = values;
    if (isCat && state.catFind) { const w = words(state.catFind).join(' '); vals = vals.filter((v) => words(v.label).join(' ').includes(w)); }
    const limit = isCat && !state.catOpen && !state.catFind ? 6 : 999;
    const opts = vals.slice(0, limit).map((v) => `<label class="tc-so__opt${v.count ? '' : ' is-zero'}"><input type="checkbox" data-f="${key}" value="${esc(v.value)}" ${sel.has(v.value) ? 'checked' : ''}><span>${esc(v.label)}</span><small>${v.count}</small></label>`).join('');
    return `<div class="tc-so__facet"><h3>${esc(title)}</h3>
      ${isCat && values.length > 8 ? `<input class="tc-so__find" type="search" placeholder="${esc(T.find)}" value="${esc(state.catFind)}" data-cat-find>` : ''}
      <div data-opts="${key}">${opts}</div>
      ${isCat && !state.catFind && vals.length > 6 ? `<button type="button" class="tc-so__toggle" data-cat-more>${esc(state.catOpen ? T.less : T.more)}</button>` : ''}
    </div>`;
  }

  function render() {
    const d = state.data;
    if (!d) return;
    body.className = 'tc-so__body';
    if (!d.fams.length) {
      body.className = 'tc-so__body is-empty';
      body.innerHTML = `<p class="tc-so__notice">${esc(T.no_exact.replace('[q]', state.q))}</p>` +
        (d.related.length ? `<div class="tc-so__grid tc-gama__grid">${d.related.map(card).join('')}</div>` : `<p class="tc-so__hint">${esc(T.no_results)}</p>`);
      return;
    }
    // facet values with counts (each facet counted with the other facets applied)
    const count = (skip, test) => d.fams.filter((f) => passes(f, skip) && test(f)).length;
    const catKeys = [...new Set(d.fams.flatMap((f) => f.c))];
    const catVals = catKeys.map((h) => ({ value: h, label: d.cats[h].t, count: count('cat', (f) => f.c.includes(h)) }))
      .sort((a, b) => b.count - a.count || a.label.localeCompare(b.label));
    const gamaKeys = [...new Set(d.fams.map((f) => f.g).filter(Boolean))];
    const gamaVals = gamaKeys.map((g) => ({ value: g, label: g, count: count('gama', (f) => f.g === g) }))
      .sort((a, b) => b.count - a.count || a.label.localeCompare(b.label));
    const [lo, hi] = d.pBounds;
    const pmin = state.pmin ?? lo, pmax = state.pmax ?? hi;
    const span = Math.max(hi - lo, 1);

    const list = filtered();
    const n = list.length;
    const countTxt = (n === 1 ? T.results_one : T.results).replace('[count]', `<strong>${n}</strong>`).replace('[q]', esc(state.q));
    const pills = [
      ...[...state.cats].map((h) => `<button type="button" class="tc-so__pill" data-rm="cat" data-v="${esc(h)}">${esc(d.cats[h] ? d.cats[h].t : h)} ✕</button>`),
      ...[...state.gamas].map((g) => `<button type="button" class="tc-so__pill" data-rm="gama" data-v="${esc(g)}">${esc(g)} ✕</button>`),
      ...(state.pmin != null || state.pmax != null ? [`<button type="button" class="tc-so__pill" data-rm="price">${esc(T.price)}: ${fmt(pmin * 100)} – ${fmt(pmax * 100)} ✕</button>`] : []),
    ];

    body.innerHTML = `
      <aside class="tc-so__facets" data-facets>
        ${catVals.length ? facetList('cat', T.category, catVals) : ''}
        ${gamaVals.length > 1 || state.gamas.size ? facetList('gama', T.gama, gamaVals) : ''}
        ${hi > lo ? `<div class="tc-so__facet"><h3>${esc(T.price)}</h3>
          <div class="tc-so__range"><span class="tc-so__range-fill" style="left:${((pmin - lo) / span) * 100}%;right:${100 - ((pmax - lo) / span) * 100}%"></span>
            <input type="range" min="${lo}" max="${hi}" step="1" value="${pmin}" data-range="min" aria-label="${esc(T.from_price)}">
            <input type="range" min="${lo}" max="${hi}" step="1" value="${pmax}" data-range="max" aria-label="${esc(T.to_price)}"></div>
          <div class="tc-so__prices"><label>${esc(T.from_price)}<input type="number" min="${lo}" max="${hi}" value="${pmin}" data-price="min"></label><label>${esc(T.to_price)}<input type="number" min="${lo}" max="${hi}" value="${pmax}" data-price="max"></label></div>
        </div>` : ''}
        <div class="tc-so__drawer-foot"><button type="button" class="tc-info__cta" data-close-facets>${esc(T.show.replace('[count]', n))}</button></div>
      </aside>
      <div class="tc-so__main">
        ${d.partial ? `<p class="tc-so__notice">${esc(T.no_exact.replace('[q]', state.q))}</p>` : ''}
        <div class="tc-so__head">
          <p class="tc-so__count">${countTxt}</p>
          <div class="tc-so__sort">
            <button type="button" class="tc-so__filters-btn" data-open-facets>${esc(T.filters)}${pills.length ? ` (${pills.length})` : ''}</button>
            <span>${esc(T.sort_by)}</span>
            <select data-sort>
              ${[['rel', T.sort_rel], ['pa', T.sort_pa], ['pd', T.sort_pd], ['az', T.sort_az]].map(([v, l]) => `<option value="${v}" ${state.sort === v ? 'selected' : ''}>${esc(l)}</option>`).join('')}
            </select>
          </div>
        </div>
        ${pills.length ? `<div class="tc-so__active">${pills.join('')}<button type="button" class="tc-so__pill tc-so__pill--clear" data-rm="all">${esc(T.clear)}</button></div>` : ''}
        <div class="tc-so__grid tc-gama__grid">${list.slice(0, state.shown).map(card).join('')}</div>
        ${n > state.shown ? `<div class="tc-so__more"><button type="button" class="tc-info__cta" data-more>${esc(T.load_more)}</button></div>` : ''}
        ${d.related.length && !pills.length ? `<section class="tc-so__related"><h3>${esc(T.related)}</h3><div class="tc-so__related-grid">${d.related.slice(0, 6).map(smallCard).join('')}</div></section>` : ''}
      </div>`;
  }

  // ---------- interactions ----------
  body.addEventListener('change', (e) => {
    const t = e.target;
    if (t.dataset.f) {
      const set = t.dataset.f === 'cat' ? state.cats : state.gamas;
      t.checked ? set.add(t.value) : set.delete(t.value);
      state.shown = PAGE; render(); keepDrawer();
    } else if (t.dataset.sort) {
      state.sort = t.value; state.shown = PAGE; render();
    } else if (t.dataset.price) {
      const v = parseInt(t.value, 10);
      const [lo, hi] = state.data.pBounds;
      if (t.dataset.price === 'min') state.pmin = isNaN(v) || v <= lo ? null : v; else state.pmax = isNaN(v) || v >= hi ? null : v;
      state.shown = PAGE; render(); keepDrawer();
    } else if (t.dataset.range) {
      const [lo, hi] = state.data.pBounds;
      const v = parseInt(t.value, 10);
      if (t.dataset.range === 'min') state.pmin = v <= lo ? null : Math.min(v, state.pmax ?? hi);
      else state.pmax = v >= hi ? null : Math.max(v, state.pmin ?? lo);
      state.shown = PAGE; render(); keepDrawer();
    }
  });
  // live feedback on the price slider while dragging (numbers + fill), filtering on release
  body.addEventListener('input', (e) => {
    const t = e.target;
    if (t.dataset.catFind !== undefined) {
      state.catFind = t.value;
      render();
      const f = body.querySelector('[data-cat-find]');
      if (f) { f.focus(); f.setSelectionRange(f.value.length, f.value.length); }
      keepDrawer();
      return;
    }
    if (!t.dataset.range) return;
    const box = t.closest('.tc-so__facet');
    const [a, b] = [...box.querySelectorAll('[data-range]')].map((x) => parseInt(x.value, 10));
    const [lo, hi] = state.data.pBounds, span = Math.max(hi - lo, 1);
    const mn = Math.min(a, b), mx = Math.max(a, b);
    box.querySelector('[data-price="min"]').value = mn;
    box.querySelector('[data-price="max"]').value = mx;
    const fill = box.querySelector('.tc-so__range-fill');
    fill.style.left = ((mn - lo) / span) * 100 + '%';
    fill.style.right = 100 - ((mx - lo) / span) * 100 + '%';
  });
  let drawerOpen = false;
  const keepDrawer = () => { if (drawerOpen) { const f = body.querySelector('[data-facets]'); if (f) f.classList.add('is-open'); } };
  body.addEventListener('click', (e) => {
    const t = e.target.closest('button');
    if (!t) return;
    if (t.dataset.more !== undefined) { state.shown += PAGE; render(); }
    else if (t.dataset.catMore !== undefined) { state.catOpen = !state.catOpen; render(); keepDrawer(); }
    else if (t.dataset.openFacets !== undefined) { drawerOpen = true; keepDrawer(); }
    else if (t.dataset.closeFacets !== undefined) { drawerOpen = false; body.querySelector('[data-facets]').classList.remove('is-open'); }
    else if (t.dataset.rm) {
      if (t.dataset.rm === 'cat') state.cats.delete(t.dataset.v);
      else if (t.dataset.rm === 'gama') state.gamas.delete(t.dataset.v);
      else if (t.dataset.rm === 'price') state.pmin = state.pmax = null;
      else { state.cats.clear(); state.gamas.clear(); state.pmin = state.pmax = null; }
      state.shown = PAGE; render();
    }
  });

  // GA4 / Shopify analytics: search event (only if a tracker exists)
  function track(q, n) {
    try {
      if (window.gtag) window.gtag('event', 'search', { search_term: q, results: n });
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('search_overlay', { query: q, results: n });
    } catch (e) { /* ignore */ }
  }

  // open from a shared link (#tc-search?q=…)
  if (location.hash.startsWith(HASH)) {
    opened = true;
    open(new URLSearchParams(location.hash.split('?')[1] || '').get('q') || '', false);
  }
})();
